module.exports = __webpack_public_path__ + "img/email.a772f690.svg";